module.exports = __webpack_public_path__ + "img/translationeditor_15.bfa0982e.jpg";